import { TRootState } from "../../types"

export const getJobsSelector = (state: TRootState) => state.jobs
